import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-portal-layout',
	templateUrl: './portal-layout.component.html',
	styleUrls: ['./portal-layout.component.css']
})
export class PortalLayoutComponent implements OnInit {

	screenWidth: number;
	isOpenMenu: boolean;

	constructor(private cdr: ChangeDetectorRef) {
		this.getScreenSize();
	}

	ngOnInit() {
	}
	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
	  setTimeout(() => {
		this.screenWidth = window.innerWidth; // ancho real de la ventana (antes screen.width)
		this.cdr.detectChanges(); // Detect changes manually
	  });
	}

	onMenuChange(): void {
		this.isOpenMenu = !this.isOpenMenu;
	  }

}
